import * as React from 'react';

import { ToolInvocation } from '../types';

import { ToolCallProps } from './DefaultToolCall';
import { ToolStatus } from './ToolStatus';
import * as UserActions from './UserActions';

export const UpdateStudyToolCall: React.FC<ToolCallProps> = ({ toolInvocation, message }) => (
  <div className='mt-2'>
    <UserActions.SavedDraft message={message} />
    <ToolStatus state={toolInvocation.state} doneText='Draft study updated.' executingText='Updating draft study...' />
  </div>
);
